import { IdentificationTypeService } from "../../services/models/identificationType";
const moduleIdentificationType = {
	namespaced: true,
	state: {
		identificationTypes: [],
		loading: false,
	},
	getters: {
		getIdentificationTypes(state) {
			return state.identificationTypes;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadIdentificationTypes(state, identificationTypes) {
			state.identificationTypes = identificationTypes;
		}
	},
	actions: {
		async loadIdentificationTypes({ commit, state }) {
			state.loading = true;
			let identificationTypes = await IdentificationTypeService.getAll();
			commit("loadIdentificationTypes", identificationTypes);
			state.loading = false;
		}
	}
}

export default moduleIdentificationType;